export default __webpack_public_path__ + "static/winner-bg-img-2-9ed5ccc722227eaef4912956157043d5.png";